import React from 'react';
import { ProfileImage } from 'components/ProfileImage';
import { SecondaryButton, PrimaryButton } from 'styleguide/Buttons';
import { H5, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { FolderDetailViewModel } from '../FolderDetailViewModel';
import { Link } from 'components/Link';
import { observer } from 'mobx-react-lite';
import { HideOnPhoneWrapper, ShowOnPhoneWrapper } from 'styleguide/Breakpoints';
import { DividerLine } from 'styleguide/DividerLine';
import { FlexRow } from 'styleguide/Row';
import { t } from 'translations/t';

export const FolderOwnerContent = observer(({ vm }: { vm: FolderDetailViewModel }) => {
  return (
    <View>
      <View>
        <Link href={`/user/${vm.username}`}>
          <HideOnPhoneWrapper style={{ display: 'flex' }}>
            <ProfileImage diameter={56} source={vm.profilePic} />
            <View style={{ marginInlineStart: Spacing.md, justifyContent: 'center' }}>
              <P2 type="secondary">{t('web.folderDetail.createdBy')}</P2>
              <H5>{vm.username}</H5>
            </View>
          </HideOnPhoneWrapper>
          <ShowOnPhoneWrapper>
            <FlexRow style={{ margin: `${Spacing.md}px 0px`, gap: Spacing.sm }}>
              <ProfileImage diameter={24} source={vm.profilePic} />
              <P2 type="secondary">
                {t('web.folderDetail.createdByUser', { username: vm.username })}
              </P2>
            </FlexRow>
            <DividerLine />
          </ShowOnPhoneWrapper>
        </Link>
      </View>
      {vm.isAuthenticated &&
        (vm.isFolderSaved || vm.isUsersFolder ? (
          <View style={{ marginTop: Spacing.md }}>
            <SecondaryButton
              title={t('web.folderDetail.copyLinkToFolder')}
              onClick={vm.onCopyUrl}
              iconType={'link'}
            />
          </View>
        ) : (
          <View style={{ marginTop: Spacing.md }}>
            {!vm.isFolderEmpty && (
              <PrimaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onSaveFolder}
                loading={vm.isSavingFolder}
              />
            )}
            <SecondaryButton
              title={t('web.folderDetail.copyLinkToFolder')}
              onClick={vm.onCopyUrl}
              iconType={'link'}
            />
          </View>
        ))}
    </View>
  );
});
